<div class="main-wrapper">

	<div [@fadeInOutAnimationJS] *ngIf="app.isLoading && app?.isPlatformBrowserVar" class="Loadinglayout">
		<!-- <img [ngClass]="this.app?.getUserLanguage() == 'en' ? 'rl' : 'lr'" class="imgLoading" src="./assets/img/XOsX.gif" alt="loading" /> -->
		<img [ngClass]="this.app?.getUserLanguage() == 'en' ? 'rl' : 'lr'" class="imgLoading" src="./assets/img/navbar/whiteLogo.png" alt="loading" />
	</div>


	<app-headerboot *ngIf="app?.isPlatformBrowserVar"></app-headerboot>

	<main>
		<router-outlet></router-outlet>
	</main>

	<app-footer *ngIf="app?.isPlatformBrowserVar"></app-footer>
</div>